import React from "react";
import { UsergroupAddOutlined } from "@ant-design/icons";
import { RiUserStarLine } from "react-icons/ri";

const PartyIcon = ({ partyType, size = undefined }) => {
  if (partyType.toLowerCase().includes("shared")) {
    return <UsergroupAddOutlined size={size} />;
  } else {
    return <RiUserStarLine size={size} />;
  }
};

export default PartyIcon;
